import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-meet-the-staff',
    templateUrl: './meet-the-staff.component.html',
    styleUrls: ['./meet-the-staff.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MeetTheStaffComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
